<template lang="pug">
  .input-select
    v-select(
      :label="label"
      :readonly="readonly"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :rules="getRules"
      :value="getValue"
      :return-object="returnObject"
      :required="required"
      :disabled="disabled"
      @blur="onChange($event)"
      @input="onInput($event)"
      :placeholder="placeholder"
      :clearable="clearable"
      outline
      :hide-details="hideDetails"
      :multiple="multiple"
      :chips="multiple"
      :deletable-chips="deletableChips"
    )
</template>

<script>
import InputSelectMixin from 'Support/components/inputs/InputSelectMixin';

export default {
  name: 'InputSelect',
  mixins: [InputSelectMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: '',
    },
    itemValue: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [Object, String, Array, Number],
      default() {
        return {};
      },
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    deletableChips: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
  .input-select
    .theme--light
      &.v-text-field--outline
        & > .v-input__control
          & > .v-input__slot
            height 45px
            min-height 45px
            border solid 1px #E0E0E0
            box-sizing border-box
            margin-top 5px
  .input-select
    .theme--light
      &.v-text-field--outline
        &:not(.v-input--is-focused):not(.v-input--has-state)
          & > .v-input__control
            & > .v-input__slot
              &:hover
                border 1px solid #369CE2
                color #369CE2
  .input-select .v-text-field--box .v-label,
  .input-select .v-text-field--full-width .v-label,
  .input-select .v-text-field--outline .v-label
    top 12px
    font-size 14px
  .input-select .v-text-field--box input,
  .input-select .v-text-field--full-width input,
  .input-select .v-text-field--outline input
    margin-top 6px
  .input-select .v-text-field .v-label--active
    top -2px !important
    background #FAFAFA
    padding 0 5px
  .input-select .v-text-field--box:hover .v-label,
  .input-select .v-text-field--full-width:hover .v-label,
  .input-select .v-text-field--outline:hover .v-label
    color #369CE2
  .input-select .v-input--is-focused .v-input__slot
    border 1px solid #369CE2 !important
  .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field.v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field.v-text-field--enclosed .v-input__append-inner,
  .v-text-field.v-text-field--enclosed .v-input__append-outer
    margin-top 10px
  .v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections
    padding-top 0
</style>
